"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMELINE_RESPONSE_EXAMPLE = void 0;
exports.TIMELINE_RESPONSE_EXAMPLE = [
    { type: 'VISIT', id: '10101010-1010-1010-1010-101010101010', occurredAt: '2026-07-09T08:30:00.000Z' },
    { type: 'ENCOUNTER', id: '20202020-2020-2020-2020-202020202020', occurredAt: '2026-07-09T08:45:00.000Z' },
];
//# sourceMappingURL=search.response.js.map